import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import cookie from "js-cookie"

function ViewPageBooking() {

    const [count, setCount] = useState([])
    const idd = useParams().id
    const navigate = useNavigate()
    const getCookieUser = cookie.get("user");
    const userInfo = getCookieUser ? JSON.parse(getCookieUser) : null;
    const getItemsCount = async () => {
        try {
            const result = await axios.get(
              `${process.env.REACT_APP_API_URL}/singlebookingForAdmin/${idd}`,
              {
                headers: {
                  Authorization: `Bearer ${userInfo?.token}`,
                },
              }
            );
            console.log(result, "result")
            setCount(result.data.data)
        } catch (error) {
            console.log(error)
        }
    }
    useEffect(() => {
        getItemsCount()
    }, [])

    const backButton = () => {
        navigate(-1)
    }

    return (
        <div className="d-flex">
            {/* Sidebar */}
            <div className="bg-dark text-white p-3" style={{ width: '250px', minHeight: '100vh' }}>
                <h4 className="text-center text-white mb-4">Admin Panel</h4>
                <ul className="nav flex-column">
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="#"><i className="fas fa-tachometer-alt me-2"></i>Dashboard</a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/UserTable"><i className="fas fa-users me-2"></i>Users</a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/ContactUsTable"><i className="fas fa-tools me-2"></i>Contact Us</a>
                    </li>
                    <li className="nav-item mb-2">
                        <a className="nav-link text-white" href="/BookingTable"><i className="fas fa-tools me-2"></i>Washing Services</a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link text-white" href="#"><i className="fas fa-sign-out-alt me-2"></i>Logout</a>
                    </li>
                </ul>
            </div>

            {/* Main Content */}
            <div className="p-4 flex-grow-1" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
                <h2 className="mb-4">Car Washing Service Details</h2>
                <div className="card shadow-sm border-0 rounded-3 p-4">
                    <div className="row mb-3">
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Full Name</label>
                            <input type="text" className="form-control" value={count?.name} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Email</label>
                            <input type="text" className="form-control" value={count?.email} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Country</label>
                            <input type="text" className="form-control" value={count?.country} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">State</label>
                            <input type="text" className="form-control" value={count?.state} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Phone Number</label>
                            <input type="text" className="form-control" value={count?.phoneNumber || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Service Type</label>
                            <input type="text" className="form-control" value={count?.serviceType || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Vehicle Type</label>
                            <input type="text" className="form-control" value={count?.vehicleType || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Vehicle Model</label>
                            <input type="text" className="form-control" value={count?.vehicleModel || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Vehicle Number</label>
                            <input type="text" className="form-control" value={count?.vehicleNumber || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Booking Date</label>
                            <input 
                                type="text" 
                                className="form-control" 
                                value={
                                    count?.date
                                        ? new Date(count.date).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "N/A"
                                } 
                                readOnly 
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Time Slot</label>
                            <input type="text" className="form-control" value={count?.timeSlot || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Service Type</label>
                            <input type="text" className="form-control" value={count?.carBookingId?.title || "N/A"} readOnly />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Washing Price</label>
                            <input type="text" className="form-control" value={`Rs. ${count?.carBookingId?.price || "N/A"}`} readOnly />
                        </div>
                        <div className="col-md-12 mb-3">
                            <label className="form-label fw-bold">Additional Notes</label>
                            <textarea className="form-control" value={count?.notes || "N/A"} readOnly rows="3" />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Status</label>
                            <input
                                type="text"
                                className="form-control"
                                value={
                                    count?.status === 0
                                        ? "Pending"
                                        : count?.status === 1
                                            ? "Accepted"
                                            : count?.status === 2
                                                ? "Rejected"
                                                : count?.status === 3
                                                    ? "In-Progress"
                                                    : count?.status === 4
                                                        ? "Completed"
                                                        : "N/A"
                                }
                                readOnly
                            />
                        </div>
                        {(count?.country || count?.state || count?.city) && (
                            <>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">Country</label>
                                    <input type="text" className="form-control" value={count?.country || "N/A"} readOnly />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">State</label>
                                    <input type="text" className="form-control" value={count?.state || "N/A"} readOnly />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-bold">City</label>
                                    <input type="text" className="form-control" value={count?.city || "N/A"} readOnly />
                                </div>
                            </>
                        )}

                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Registered On</label>
                            <input
                                type="text"
                                className="form-control"
                                value={
                                    count?.createdAt
                                        ? new Date(count.createdAt).toLocaleDateString("en-GB", {
                                            day: "2-digit",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : ""
                                }
                                readOnly
                            />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label className="form-label fw-bold">Car Image</label>
                            <img style={{ height: "200px", width: "200px" }} src={count?.carBookingId?.image} className="form-control" alt="" />
                        </div>
                    </div>
                    <div className="text-end">
                        <button onClick={backButton} className="btn btn-secondary">
                            <i className="fas fa-arrow-left me-2"></i>Go Back
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ViewPageBooking;
